var constants = {
  QUIZ_STATUS_NEW: 0,
  QUIZ_STATUS_OPEN: 1,
  QUIZ_STATUS_RUNNING: 2,
  QUIZ_STATUS_RUNNING_CLOSED: 3,
  QUIZ_STATUS_ENDED: 4,
  QUIZ_STATUS_FINALIZED: 5,

  USER_ROLE_GUEST: 0,
  USER_ROLE_USER: 1,
  USER_ROLE_HOST: 10,
  USER_ROLE_ADMIN: 100,

  TEAM_ROLE_MEMBER: 0,
  TEAM_ROLE_OWNER: 1,

  PRESET_ID_HOST_WEB_LINK: 1
};

module.exports = constants;
